/**
 * API base for the admin SPA.
 *
 * The admin console calls its OWN origin for `/internal/admin/*` (same-origin),
 * so the base is the empty string (relative paths). This keeps the API's
 * deliberate no-CORS / CSRF posture intact — the browser never makes a
 * cross-origin request.
 *
 * - **Production:** a Cloudflare Pages Function
 *   (`apps/admin/functions/internal/admin/[[path]].ts`) transparently proxies
 *   `/internal/admin/*` on the admin host (e.g. ops2026.sill.so) to the real API
 *   (api.sill.so). The `sill_staff_session` cookie is `Domain=.sill.so`, so it
 *   flows through correctly.
 * - **Dev:** `vite.config.ts` `server.proxy` forwards `/internal/admin` to the
 *   local API (default http://localhost:8080).
 *
 * No `VITE_API_ORIGIN` is needed; relative URLs resolve against the page origin.
 */

export const API_ORIGIN: string = '';
